module.exports = __webpack_public_path__ + "static/img/fax.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fax.jpg
// module id = tJez
// module chunks = 1